module.exports = __webpack_public_path__ + "assets/images/cosmote_3.70fa8b8caacff6019ec285f79ff6ebe8.png";